import classNames from 'classnames';
import React from 'react';

import styles from './TableRow.module.scss';

export type TableRowProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  isHeader?: boolean;
  ref?: React.Ref<HTMLDivElement>;
};

export const TableRow: React.FC<TableRowProps> = ({
  children,
  className = '',
  onClick,
  isHeader = false,
  ref,
}) => {
  return (
    <div
      ref={ref}
      className={classNames(
        styles.tableRow,
        {
          [styles.header]: isHeader,
        },
        className
      )}
      style={{
        gridTemplateColumns: `minmax(154px, 186px) repeat(15, 1fr)`,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
